var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6444 7.50014C16.6444 7.63275 16.5918 7.75993 16.498 7.8537C16.4042 7.94746 16.2771 8.00014 16.1444 8.00014H2.35145L8.49845 14.1461C8.59234 14.24 8.64508 14.3674 8.64508 14.5001C8.64508 14.6329 8.59234 14.7603 8.49845 14.8541C8.45196 14.9006 8.39677 14.9375 8.33603 14.9627C8.27529 14.9878 8.21019 15.0008 8.14445 15.0008C8.01167 15.0008 7.88434 14.948 7.79045 14.8541L0.790448 7.85414C0.743885 7.8077 0.706942 7.75252 0.681736 7.69178C0.656529 7.63103 0.643555 7.56591 0.643555 7.50014C0.643555 7.43438 0.656529 7.36926 0.681736 7.30851C0.706942 7.24776 0.743885 7.19259 0.790448 7.14614L7.79045 0.146143C7.88434 0.0522566 8.01167 -0.000488282 8.14445 -0.000488281C8.27722 -0.00048828 8.40456 0.0522566 8.49845 0.146143C8.59234 0.24003 8.64508 0.367368 8.64508 0.500143C8.64508 0.632919 8.59234 0.760257 8.49845 0.854143L2.35145 7.00014H16.1444C16.2771 7.00014 16.4042 7.05282 16.498 7.14659C16.5918 7.24036 16.6444 7.36753 16.6444 7.50014Z",
    fill: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlue);
export default __webpack_public_path__ + "static/media/left-blue.1f5f67023b762f5c3c25273485783d6c.svg";
export { ForwardRef as ReactComponent };